import { render, staticRenderFns } from "./product_add.vue?vue&type=template&id=717ea5ea&scoped=true&"
import script from "./product_add.vue?vue&type=script&lang=js&"
export * from "./product_add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "717ea5ea",
  null
  
)

export default component.exports